module.exports = __webpack_public_path__ + "static/media/_gosquared.b444ada8.png";